import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import Breadcrumb from '../../components/Breadcrumb';
import { repoImageUpload, repoModelUpload } from '../../services/apiService';
import Form from "../../components/form/Form";


interface RepoProps {
    setError: Dispatch<SetStateAction<string | null>>;
    setIsError: Dispatch<SetStateAction<boolean>>;
}

const Repo: React.FC<RepoProps> = ({ setError, setIsError }) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingMes,setLoadingMes]= useState('')
    const [repoData,setRepoData] = useState<any[]>([{}]);
    const [selectedModel,setSelectedModel] = useState(null)
    const [modelUploaded,setModelUploaded] = useState(false);
    const [imageUploded,setImageUploaded] = useState(false);
    const [sms,setSms] = useState(false)

    const breadcrumbs = [
        { label: '3D Repository', href: '' },
    ];

    const fields = [
        { name: 'name', label: 'Model Name', placeholder: 'Enter the name of your 3D model'},
        { name: 'lable', label: 'Model Lable', placeholder: 'Enter the lable of your 3D model'},
        { name: 'line_break', label: 'line break', placeholder: 'line break',type:'lineBreak'},
        { name: 'select_model', label: 'Upload your 3D Model (.fbx within 50 mb)', placeholder: 'select model' , type:'file'},
        { name: 'model_button', label: 'Upload Model', placeholder: 'Upload Model',type:'button'},
        { name: 'line_break', label: 'line break', placeholder: 'line break',type:'lineBreak'},
        { name: 'select_image', label: 'Upload Your Logo for Branding(500 x 120)', placeholder: 'select image' , type:'file'},
        { name: 'img_button', label: 'Upload Image', placeholder: 'Upload Image',type:'button'},
        { name: 'line_break', label: 'line break', placeholder: 'line break',type:'lineBreak'},
        { name: 'type', label: 'Choose a Type', placeholder: 'Type',type:'select' },
    ]

    const [repoFields, setRepoFields] = useState<{ [key: string]: typeof fields }[]>([]);

    useEffect(()=>{
        setRepoFields([{ project: [...fields] }]);
    },[])

    const model_upload = async (formData:any) => {
        setLoading(true)
        setLoadingMes('uploading')
        if(selectedModel){
            const file = formData.get('file');  
            const fileName = file && file.name; 
            const fileExtension = fileName.split('.').pop(); 
            if(fileExtension === 'fbx'){
                const result = await repoModelUpload(formData)
                setRepoData((prevData) => {
                    const updatedProjectData = [...prevData];
                    if (updatedProjectData.length > 0) {
                        updatedProjectData[0].model_url = result.data.s3_key;
                    } else {
                        updatedProjectData.push({ model_url: result.data.s3_key });
                    }
                    return updatedProjectData;
                });
                setModelUploaded(true)
                setLoading(false);
                setSms(true)
                return result
            }
            else{
                alert('only ".fbx" files accepted')
                const result = {status : 4000}
                setLoading(false);
                return result
            }
        }
        else{
            alert('Select a model to upload')
        }
    }

    const image_upload = (formData:any) => {
        setLoading(true);
        setLoadingMes('uploading');
        return new Promise((resolve, reject) => {
            const file = formData.get('file');
            const fileName = file.name;
            const fileExtension = fileName.split('.').pop();
            if(fileExtension === 'png' || fileExtension === 'jpeg') {
                const img = new Image();
                img.onload = async () => {
                    if (img.width === 500 && img.height === 120) {
                        const result = await repoImageUpload(formData);
                        setImageUploaded(true);
                        setRepoData((prevData) => {
                            const updatedProjectData = [...prevData];
                            if (updatedProjectData.length > 0) {
                                updatedProjectData[0].image_url = result.data.s3_key;
                            } else {
                                updatedProjectData.push({ image_url: result.data.s3_key });
                            }
                            return updatedProjectData;
                        });
                        setLoading(false);
                        resolve(result);
                    } else {
                        alert('Only "500 x 120" resolution allowed for branding image');
                        setLoading(false);
                        resolve({ status: 2000 });
                    }
                };
                img.onerror = () => {
                    alert('Error loading image');
                    setLoading(false);
                    reject(new Error('Error loading image'));
                };
                img.src = URL.createObjectURL(file);
            } else {
                alert('Only ".png" and ".jpeg" are allowed for branding image');
                setLoading(false);
                resolve({ status: 2000 });
            }
        });
    };
    const handleRepoChange = (
        e: (React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>),
            index: number,
            field: boolean
        ) => {
            const name = e.target.name 
            const value = e.target.value

            setRepoData((prev: any[]) => {
                const updatedProject = [...prev];
                const project = updatedProject[index] || {};
                project[name] = value;
                updatedProject[index] = project;
                return updatedProject;
            });
            
    };
    return  <>
                <Breadcrumb breadcrumbs={breadcrumbs} />
                <div className="px-10 flex justify-between items-center mb-5">
                        <div className="px-10 py-5 ps-0 text-lg flex">
                                <p className='mr-4' style={{fontSize:'30px',color:'#0050C8',fontWeight:'bold'}}>3D Repository Upload</p>
                                        {/* {index !== 0 &&  */}
                                            {/* <button type="button" className="flex items-center"><FontAwesomeIcon icon={faTrash} className='text-sm' /></button>} */}
                        </div>
                        <button
                            disabled={repoData.length != 0 && (!repoData[0].hasOwnProperty('model_url') || repoData[0]['model_url'] === '' || repoData[0]['model_url'] === null)}
                            type="submit"
                            style={{backgroundColor:`${(repoData.length != 0 && (!repoData[0].hasOwnProperty('model_url') || repoData[0]['model_url'] === '' || repoData[0]['model_url'] === null)) ? 'gray' : '#058C7E'}`}}
                            className={`text-white  focus:ring-4 focus:outline-none focus:ring-green-300 rounded-lg text-sm px-5 py-2.5 text-center w-1/5 font-bold ${(repoData.length != 0 && repoData[0].hasOwnProperty('model_url') == false) || (repoData.length != 0 && repoData[0]['model_url'] === '') ? '' : 'hover:bg-green-800'}`}
                        >
                            Save
                        </button>
                </div>
                {Array.isArray(repoFields) && repoFields.map((fieldsObj, index) => {
                            const storyKey = Object.keys(fieldsObj)[0];
                            return (
                                <div key={index}>
                                    <div className='w-full h-auto flex'>
                                        <div className='w-full px-5 flex flex-wrap mb-10'>
                                            <Form fields={fieldsObj[storyKey]} handleChange={(e: (React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>), field) => handleRepoChange(e, index, field)} data={[]} />
                                        </div>
                                    </div>
                                </div>
                            )
                        
                })}
                {loading &&
                    <div style={{position:'fixed',top:'0',bottom:'0',width:'100%',display:'flex',alignItems:'center',justifyContent:'center',backgroundColor: 'rgba(0, 0, 0, 0.5)'}}>
                        <div style={{background:'white',border:' 2px solid #0050C8'}} className="flex items-center rounded px-7 py-3">
                            <div className="spinner me-2"></div>
                            {
                                loadingMes === 'converting' ?  (<p className="text-blue-700">Converting please wait...</p>)  : loadingMes === 'uploading' ? <p className="text-blue-700">Uploading please wait...</p> : loadingMes === 'saving' ? <p className="text-blue-700">Saving please wait...</p> : <p className="text-blue-700">Loading please wait...</p> 
                            }
                        </div>
                    </div>
                }
            </>
}

export default Repo;